export const COUNTRY_CREATE_RESET = 'COUNTRY_CREATE_RESET'
export const COUNTRY_CREATE_SET_CREATED = 'COUNTRY_CREATE_SET_CREATED'
export const COUNTRY_CREATE_SET_ERROR = 'COUNTRY_CREATE_SET_ERROR'
export const COUNTRY_CREATE_SET_VIOLATIONS = 'COUNTRY_CREATE_SET_VIOLATIONS'
export const COUNTRY_CREATE_TOGGLE_LOADING = 'COUNTRY_CREATE_TOGGLE_LOADING'
